<template>
	<div class="page-container">
		<md-dialog-alert
	      :md-active.sync="alert"
	      :md-content="msgAlert"
	      md-confirm-text="Ok" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Meu Caixa
				</span>
			</md-app-toolbar>
			<md-app-content>
				<div class="fundo-geral" style="min-height: 100%;">
					<md-card style="margin-bottom: 10px;">
						<md-card-content style="padding-top: 0;padding-bottom: 0;">
							<div class="md-layout md-gutter" v-if="!hideFilter">
			            		<div class="md-layout-item">
									<md-datepicker v-model="de" md-immediately />
								</div>
								<div class="md-layout-item">
									<md-datepicker v-model="ate" md-immediately />
								</div>
							</div>
							<div class="md-layout md-gutter" v-if="!loadingCashflow">
								<div class="md-layout-item" v-if="!hideFilter">
									<md-button class="md-raised md-primary" style="width: 95%;" @click="filtrar()">FILTRAR</md-button>
								</div>
								<div class="md-layout-item">
									<md-button class="md-raised md-primary" style="width: 95%;" @click="toggleFilter()"><md-icon>{{ titleBtnToggleFilter }}</md-icon></md-button>
								</div>
							</div>
						</md-card-content>
					</md-card>
					<md-card v-if="!loadingCashflow" style="margin-bottom: 10px;">
						<md-card-content>
							<div class="md-layout md-gutter" style="font-weight: bold;">
			            		<div class="md-layout-item">
			            			QUANTIDADE
			            		</div>
			            		<div class="md-layout-item" style="text-align: right;font-size: 150%; color: #0042FF;">
			            			{{ cashflow.qtd }}
			            		</div>
							</div>
						</md-card-content>
					</md-card>
					<md-card v-if="!loadingCashflow" style="margin-bottom: 10px;">
						<md-card-content>
							<div class="md-layout md-gutter" style="font-weight: bold;">
			            		<div class="md-layout-item">
			            			TOTAL APOSTADO
			            		</div>
			            		<div class="md-layout-item" style="text-align: right;font-size: 150%; color: #43BC22;">
			            			R$ {{ cashflow.total_apostado }}
			            		</div>
							</div>
						</md-card-content>
					</md-card>
					<md-card v-if="!loadingCashflow" style="margin-bottom: 10px;">
						<md-card-content>
							<div class="md-layout md-gutter" style="font-weight: bold;">
			            		<div class="md-layout-item">
			            			TOTAL PRÊMIOS
			            		</div>
			            		<div class="md-layout-item" style="text-align: right;font-size: 150%; color: #DC1111;">
			            			R$ {{ cashflow.total_premios }}
			            		</div>
							</div>
						</md-card-content>
					</md-card>
					<md-card v-if="!loadingCashflow" style="margin-bottom: 10px;">
						<md-card-content>
							<div class="md-layout md-gutter" style="font-weight: bold;">
			            		<div class="md-layout-item">
			            			TOTAL COMISSÃO
			            		</div>
			            		<div class="md-layout-item" style="text-align: right;font-size: 150%; color: #146525;">
			            			R$ {{ cashflow.total_comissao }}
			            		</div>
							</div>
						</md-card-content>
					</md-card>
					<md-card v-if="!loadingCashflow">
						<md-card-content>
							<div class="md-layout md-gutter" style="font-weight: bold;">
			            		<div class="md-layout-item">
			            			TOTAL LÍQUIDO
			            		</div>
			            		<div class="md-layout-item" style="text-align: right;font-size: 150%; color: #2893D1;">
			            			R$ {{ cashflow.total_liquido }}
			            		</div>
							</div>
						</md-card-content>
					</md-card>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'

	export default {
		name: 'TitanCashflow',
		data () {
			return {
				de: new Date(),
				ate: new Date(),
				alert: false,
			    msgAlert: "",
			    loadingCashflow: false,
			    cashflow: {},
			    hideFilter: true
			}
		},
        methods: {
        	backHome: function() {
        		this.$router.push({ name: 'TitanHome'})
        	},
        	filtrar: function() {
        		this.loadingCashflow = true

        		var de = moment(this.de);
        		var ate = moment(this.ate);
        		if (!(de.isValid()) || !(ate.isValid())) {
        			this.msgAlert = "Período inválido."
        			this.alert = true
        			return false;
        		}

        		this.$store.commit('CASHFLOW_FILTER', { 'de': this.de, 'ate': this.ate })

        		var config = {
				  headers: {Authorization: 'Bearer  ' + this.$store.state.usuario.token}
				};

        		axios
				.get(this.$root.$data.API_URL + 'seller/cashflow/' + de.format("YYYY-MM-DD") + "/" + ate.format("YYYY-MM-DD"), config)
				.then(response => {
					this.loadingCashflow = false

					let result = response.data
					
					if (result.success) {
						this.cashflow = result.cashflow
					}
					else {
						this.msgAlert = result.message
        				this.alert = true
					}
		        });
        	},
        	toggleFilter: function() {
        		this.hideFilter = !this.hideFilter
        	},
			traduzStatus: function(status) {
				if (status == 'l') return 'Perdeu'
				else if (status == 'w') return 'Ganhou'
				else if (status == 'ca') return 'Encerrado'
				else if (status == 'c') return 'Cancelado'
				else return 'Pendente'
			},
			visualizar: function(numero) {
				this.$router.push({ name: 'TitanReprint', params: { id: numero }})
			}
        },
        mounted() {
        	//console.log(this.$store.state.tickets_filter)
        	if (this.$store.state.tickets_filter) {
				this.de = this.$store.state.tickets_filter.de
				this.ate = this.$store.state.tickets_filter.ate
			}

			this.filtrar()
		},
		computed: {
			titleBtnToggleFilter: function() {
				if (this.hideFilter) return 'keyboard_arrow_down'
				else return 'keyboard_arrow_up'
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #CB1323 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme

.logo {
	text-align: center;
	margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/TitanCashflow.vue